module.exports = __webpack_public_path__ + "img/course107_summary_unit_timelines.bd2d1a2e.png";